import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear localStorage or session data here if needed
    localStorage.clear();

    // Redirect the user to the Content page ("/") after a short delay
    const timer = setTimeout(() => {
      navigate('/');
    }, 1500); // 1.5 seconds delay (optional)

    // Clean up the timer
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div>
      <h1>You have been logged out.</h1>
      <p>Redirecting you to the home page...</p>
    </div>
  );
};

export default Logout;
